import { featureFlagClient } from '@trello/feature-flag-client';
import { connectionInformationState } from './connectionInformationState';

export interface ConnectionInformationEvent {
  eventName: string;
  payload?: string | object;
  timestamp?: number;
}

export interface AjaxEvent extends ConnectionInformationEvent {
  source: 'ajax';
}

export interface SocketRpcEvent extends ConnectionInformationEvent {
  source: 'socketRpc';
}

export interface RpcEvent extends ConnectionInformationEvent {
  source: 'rpc';
}

export function logConnectionInformation(
  event: AjaxEvent | SocketRpcEvent | RpcEvent,
) {
  if (featureFlagClient.get('fep.log-connection-information', false)) {
    connectionInformationState.setValue({
      eventLog: [
        {
          ...event,
          timestamp: Date.now(),
        },
        // Slice the array so we don't exceed the event log limit. This helps avoid every-increasing memory usage.
        ...connectionInformationState.value.eventLog.slice(
          0,
          connectionInformationState.value.eventLogLimit - 1,
        ),
      ],
    });
  }
}
